// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : INACTIVE MEMBER REPORT
// MODIFIED DATE: 29-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*********** GET INACTIVE MEMBER LIST START *********************** */
export const InActiveMemberListGet = (listData: any) => {
	const data = {
		GetInActiveMemberReportToken: listData,
	};
	const url = `${API_URL}inActiveMemberReport`;
	return makeApiCall(url, data);
};
/*********** GET INACTIVE MEMBER LIST END *********************** */
